import { CommonModule } from '@angular/common';
import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'reset-success',
  templateUrl: './reset-success.component.html',
  standalone: true,
  encapsulation: ViewEncapsulation.None,
  imports: [CommonModule],
})
export class ResetSuccessComponent {}
